angular.module('ui2.0Directives').directive('listingDashboards',["$rootScope","$http","$compile","$templateCache","aeService","entityFactory",function($rootScope,http, $compile,$templateCache,aeService,entityFactory) {
    return {
        restrict: 'AE',
        link: function (scope, elm, attrs) {
            scope.listOptions = [{id: 1, name: 'Column', chartType: 'scrollColumn2D'}, {id: 2, name: 'Stacked Column', chartType: 'stackedcolumn2d'}, {id: 3, name: 'MS Column', chartType: 'mscolumn2d'},{id: 4, name: 'MS Bar', chartType: 'msbar2d'}, {id: 5, name: 'MS Line', chartType: 'msline'}, {id: 6, name: 'Bar', chartType: 'bar2d'}, {id: 7, name: 'Line', chartType: 'scrollLine2d'}, {id: 8, name: 'Pie', chartType: 'pie2d'}, {id: 9, name: 'Doughnut', chartType: 'doughnut2d'}];
            scope.selectedChartForm = {};
            scope.yAxisOptions = [];
            scope.chartData = {};
            scope.chartDataArr = {};
            scope.docIds = [];
            scope.multiChartTypes = ['stackedcolumn2d', 'mscolumn2d', 'msbar2d', 'msline'];
            scope.singleChartTypes = ['column2d', 'bar2d', 'line', 'pie2d', 'doughnut2d'];
            scope.chartNameError = "";
            var palette = "5DADE2,3498DB,1ABC9C,73C6B6,EDBB99,34495E,99A3A4,F7BE62,99A3A4,A2D9CE,1F618D";
            scope.chartData['chart'] = {
                "showShadow": "0",
                "canvasBorderColor ": "ffffff",
                "use3dlighting": "0",
                "showAlternateVGridColor": "0",
                "toolTipPadding": "5",
                "showvalues": "0",
                "legendItemFontSize": "13",
                "formatnumberscale": "1",
                "palette": "1",
                "palettecolors": palette,
                "height": "100",
                "showPlotBorder": "0",
                "yAxisNamePadding": "10",
                "AxisLineColor": "b7b4a3",
                "lineThickness": "2",
                "connectnulldata": "0",
                "showAlternateHGridColor": "0",
                "animation": "0",
                "xAxisNamePadding": "10",
                "showPYAxisLine": "1",
                "toolTipBgColor": "555555",
                "labelDisplay": "AUTO",
                "plotGradientColor": "",
                "legendItemFontColor": "84786a",
                "toolTipBorderRadius": "5",
                "yAxisNameFontSize": "13",
                "basefont": "proxima_novaregular",
                "yAxisNameFontBold": "0",
                "toolTipBgAlpha": "80",
                "bgColor": "FFFFFF",
                "showxAxisLine": "1",
                "showyAxisLine": "1",
                "basefontcolor": "454545",
                "toolTipBorderThickness": "0",
                "divLineColor": "ffffff",
                "basefontsize": "13",
                "syaxisvaluesdecimals": "2",
                "canvasBorderThickness ": "0",
                "showYAxisValues": "1",
                "legendBorderColor": "FFFFFF",
                "enableSmartLabels": "1",
                "PYAxisMinValue": "0",
                "numDivLines": "2",
                "legendNumColumns": "4",
                "showBorder": "0",
                "maxLabelHeight": "40",
                "showCanvasBorder": "0",
                "SYAxisMinValue": "0",
                "showSYAxisLine": "1",
                "SYAxisMaxValue": "5",
                "toolTipColor": "#FFFFFF",
                "legendScrollBgColor": "C7C3B0",
                "YAxisMaxValue": "3",
                "toolTipBorderColor": "ffffff",
                "PYAxisMaxValue": "5",
                "YAxisMinValue": "0",
                "xAxisNameFontBold": "0",
                "legendItemHoverFontColor": "84786a",
                "xAxisNameFontSize": "13",
                "legendShadow": "0",
                "showlabels": "1",
                "scrollheight": "10",
                "flatScrollBars": "1",
                "scrollShowButtons": "0",
                "scrollColor": "#CCCCCC",
                // "maxLabelHeight":"50",
                "maxLabelWidthPercent":"25",

            };
            var chartConfig = scope.chartData['chart'];
            scope.setAxisOptions = function(){
                startLoader();
                let endPoint = (scope.isAEListing && !scope.elasticListing) ? "/autoextraction/getDashBoardKeys" : "/listingchart/chartaxis/"+scope.listId;

                var promise = requestData("GET", endPoint, null, false, "json");
                promise.success(function(response){
                    $rootScope.xAxisOptions = response;
                    scope.loadDashboards();
                    if(scope.aeDashboardModalInstance){
                        scope.openCreateChart();
                    }
                    stopLoader();
                });
            };
            scope.onInit = function () {
                if(!$rootScope.xAxisOptions || !$rootScope.xAxisOptions.length){
                    scope.setAxisOptions();
                }else{
                    if(scope.aeDashboardModalInstance){
                        if(! scope.dashboardList || !scope.dashboardList.length){
                            scope.loadDashboards();
                        }
                        scope.openCreateChart();
                    }else{
                        scope.loadDashboards();
                    }
                }
                startLoader();
            };
            scope.loadDashboards = function(){

                let endPoint = (scope.isAEListing && !scope.elasticListing) ? '/autoextraction/savedDashboards' : '/listingchart/fetchSavedDashboards/'+scope.listId;
                var promise1 = requestData("GET", endPoint, null, false, "json");
                promise1.success(function (data) {
                    $rootScope.dashboardList = [];
                    scope.chartDataArr = {};
                    if(!data.length){
                        stopLoader();
                    }
                    data.forEach((obj, index) => {
                        const chart = JSON.parse(obj.chartData).chartData;
                        chart.id = obj.id;
                        if(!scope.aeQCFieldAccess && ['tag1','tag2'].indexOf(chart.xaxis) >= 0){
                            //do not render chart as no permission;
                        }else{
                            $rootScope.dashboardList.push(chart);
                        }
                    });
                    if(!scope.$$phase){
                        scope.$apply();
                    }
                    stopLoader();

                    if(scope.dashboardView && !scope.aeDashboardModalInstance){
                        scope.loadDashboardCharts();
                    }
                })
            }

            scope.loadDashboardCharts = () => {
                if(_.get($rootScope.dashboardList,"length")) {
                    let batchSize = 6,
                        totalBatches = Array(Math.ceil($rootScope.dashboardList.length / batchSize)),
                        iterator = 0;

                    _.forEach(totalBatches,(batch,i) => {
                        totalBatches[i] = [];
                        for(let j=0 ; j<batchSize ;++j) {
                            if( iterator < $rootScope.dashboardList.length && $rootScope.dashboardList[iterator] ) {
                                totalBatches[i].push($rootScope.dashboardList[iterator++]);
                            }
                        }
                    });

                    const sendRequest = (obj) => {
                        return new Promise((resolve) => {
                            scope.chartDataArr[obj.id] = {};
                            scope.chartDataArr[obj.id]['chart'] = JSON.parse(JSON.stringify(chartConfig));
                            scope.chartDataArr[obj.id]['chart'].yaxisname = JSON.parse(JSON.stringify(obj.yaxisDisplay || ''));
                            scope.chartDataArr[obj.id]['chart'].xaxisname = JSON.parse(JSON.stringify(obj.xaxisDisplay || ''));
                            scope.openDashboardChart(obj, obj.id,resolve);
                        })
                    }

                    const syncApiCall = (totalBatches , index) => {
                        Promise.all(totalBatches[index].map((obj) => {
                            return sendRequest(obj);
                        })).then(res => {
                            ++index;
                            if(index < totalBatches.length) {
                                syncApiCall(totalBatches,index);
                            }
                        }).catch(err => {
                            console.error(err);
                        });
                    };

                    syncApiCall(totalBatches,0);
                }
            }
            scope.renderChart = function(chart, container, id){
                if(id){
                    var  dataSource = scope.chartDataArr[id];
                }else{
                    var dataSource = scope.chartData;
                }
                FusionCharts.ready(function () {
                    var myChart = new FusionCharts({
                        type: chart.chartType,
                        renderAt: container,
                        width: "95%",
                        height: "100%",
                        dataFormat: "json",
                        dataSource
                    }).render();
                    stopLoader();
                });
            }
            scope.setChartData = function(data,chart) {
                if (data.response && data.response.length) {
                    var notPopupChart = false;
                    if(scope.chartDataArr[chart.id]) {
                        notPopupChart = true;
                    }
                    if (["scrollColumn2D", "scrollLine2d"].includes(chart.chartType)) {
                        scope.chartData['categories'] = [{"category": []}];
                        scope.chartData['dataset'] = [{"data": []}];
                        if(notPopupChart){
                            scope.chartDataArr[chart.id]['categories'] = [{"category": []}];
                            scope.chartDataArr[chart.id]['dataset'] = [{"data": []}];
                        }
                        var inx = 0;
                        var palettecolors = ["5DADE2", "3498DB", "1ABC9C", "73C6B6", "EDBB99", "34495E", "99A3A4", "F7BE62", "99A3A4", "A2D9CE", "1F618D"];
                        data.response.forEach(obj => {
                            if (inx === palettecolors.length) {
                                inx = 0
                            }

                            obj['color'] = palettecolors[inx++]
                            scope.chartData['categories'][0]['category'].push({"label": obj.label});
                            scope.chartData['dataset'][0]['data'].push(obj);
                            if(notPopupChart){
                                scope.chartDataArr[chart.id]['categories'][0]['category'].push({"label": obj.label});
                                scope.chartDataArr[chart.id]['dataset'][0]['data'].push(obj);
                            }
                        })
                    }
                    if (scope.singleChartTypes.includes(chart.chartType)) {
                        scope.chartData['data'] = data.response;
                        if(notPopupChart){
                            scope.chartDataArr[chart.id]['data'] = data.response;
                        }
                    } else if (scope.multiChartTypes.includes(chart.chartType)) {
                        scope.chartData['categories'] = [];
                        scope.chartData[' dataset'] = [];
                        if(notPopupChart){
                            scope.chartDataArr[chart.id]['categories'] = [];
                            scope.chartDataArr[chart.id][' dataset'] = [];
                        }
                    }
                }
            }
            scope.openCreateChart = function(event){
                if(event){
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
                if(_.isEmpty(scope.selectedChartForm)){
                    scope.selectedChartForm = {chartData:$rootScope.xAxisOptions[0], chartName:null, chartType: scope.listOptions[0]};
                    var elem = angular.element(".popupAeDashboards .leftSec");
                }
                var chart =  scope.selectedChartForm.chartType;
                let postData = {};
                aeService.allRowsSelected(postData,scope,true);
                var chartData = (scope.selectedChartForm.chartData ? scope.selectedChartForm.chartData: $rootScope.xAxisOptions[0]);
                let endPoint;

                if(scope.isAEListing && !scope.elasticListing) {
                    postData = _.merge(postData, chartData);
                    endPoint = '/autoextraction/dashboards/data';
                }else {
                    postData = JSON.parse(stringify_datatable_json(true));
                    endPoint = '/listingchart/chartdata/'+listId+'?xaxis='+ chartData.xaxislevel+'&yaxis='+chartData.yaxislevel+'&chartType='+chart.id;
                }
                delete postData.$$hashKey;
                entityFactory.getReactFilterData(postData);
                if(!_.isEmpty(postData)){
                    var promise = requestData("POST", endPoint, postData, false, "json");
                }
                promise.success(function (data) {
                    angular.element("#chart"+chart.id).find(".hidechart").hide();
                        scope.chartData['chart'].xaxisname =  chartData.xaxisDisplay;
                        scope.chartData['chart'].yaxisname = chartData.yaxisDisplay;
                    if(data.response && data.response.length){
                        scope.setChartData(data,chart);
                        scope.renderChart(chart,'chart-container', null );
                    }else{
                        stopLoader();
                        var noDataHtml =   '<div class="noData"><div class="no-data-image"><img loading="lazy" alt="No Data Image" src="https://www.sirioncdn.com/src/images/no-data.svg" height="105px"/> </div>'+
                            '<span class="no-data-text">'+intl_msg[23636]+'</span> </div>';
                        angular.element("#chart-container").html(noDataHtml);
                    }
                });
                // $compile(elem)(scope);
            }
            scope.openDashboardChart = function (chart, id,apiResolver) {
                let postData = {};
                if(scope.isAEListing && !scope.elasticListing) {
                    endPoint = '/autoextraction/dashboards/data';
                    postData = {sqlQuery: chart.sqlQuery, xaxisDisplay: chart.xaxisDisplay, xaxisLevel: chart.xaxisLevel, yaxisDisplay: chart.yaxisDisplay, yaxisLevel: chart.yaxisLevel };
                }else {
                    let xaxisLevel = chart.xaxislevel || chart.xaxisLevel,
                        yaxisLevel = chart.yaxislevel || chart.yaxisLevel;
                    endPoint = '/listingchart/chartdata/'+listId+'?xaxis='+ xaxisLevel+'&yaxis='+yaxisLevel+'&chartType='+id;
                    postData = JSON.parse(stringify_datatable_json(true));
                    // delete postData.selectedColumns
                    if($(".react-filter-btn").length) {
                        postData["filterMap"]["filterJson"] = _.get(window.payload, "filterMap.filterJson");
                    }
                }
                delete chart.$$hashKey;
                if(scope.isAEListing)
                    aeService.allRowsSelected(postData,scope,true);
                // aeService.allRowsSelected(postData,scope,true);

                if(postData){
                    http.post(endPoint,postData,false,"json").then(function (resp) {
                        angular.element("#chart"+chart.id).find(".hidechart").hide();
                        if(resp.data.response && resp.data.response.length){
                            scope.setChartData(resp.data,chart);
                            scope.renderChart(chart, 'chart'+chart.id, chart.id );
                        }else{
                            stopLoader();
                            var noDataHtml =   '<div class="noData"><div class="no-data-image"><img loading="lazy" alt="No Data Image" src="https://www.sirioncdn.com/src/images/no-data.svg" height="105px"/> </div>'+
                                '<span class="no-data-text">'+intl_msg[23636]+'</span> </div>';
                            angular.element("#chart"+chart.id).html(noDataHtml);
                        }
                        apiResolver && apiResolver(true);
                    }).catch(err => {
                        apiResolver && apiResolver(true);
                    });
                }else {
                    apiResolver && apiResolver(true);
                }
            };
            scope.deleteDashboard =function(chartId){
                $rootScope.deleteIdSet =  chartId;
                const args = {
                    popupType: 'confirm',
                    str: intl_msg[6479],
                    heading: intl_msg[25772],
                    yesCbFn: $rootScope.deleteDashboardConfirmed,
                    noCbFn: scope.closePopup
                }
                SirionUtils.openSirionDialogs(args);
            };
            $rootScope.deleteDashboardConfirmed = function () {
                let endPoint,
                    deletedChartIndex = $rootScope.dashboardList.findIndex(o => o.id == scope.deleteIdSet)
                if(scope.isAEListing && !scope.elasticListing) {
                    endPoint = '/autoextraction/autoextractionCharts/delete/'+scope.deleteIdSet;

                    http.post(endPoint,null).then(function (resp) {
                        if( deletedChartIndex != -1 ) {
                            $rootScope.dashboardList.splice(deletedChartIndex,1);
                        }
                    });
                }else {
                    endPoint = '/listingchart/deleteSavedDashboard/'+listId+'/'+scope.deleteIdSet;
                    http.get(endPoint).then(function (resp) {
                        if( deletedChartIndex != -1 ) {
                            $rootScope.dashboardList.splice(deletedChartIndex,1);
                        }
                    }).catch(error => window.systemWarning(error));
                }
            };
            window.showListAndDrill = function(obj){
                if(scope.aeDashboardModalInstance){
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                $('body').click();
                var drillElem = angular.element(".showDrill");
                if(drillElem.is(":visible") ){
                    drillElem.hide();
                }
                $compile(drillElem)(scope);
                var chartContainer = angular.element(event.target).closest('.chart-container');
                if(!chartContainer.find(".showDrill").length){
                    const html = $templateCache.get("showDrill");
                    chartContainer.prepend(html);
                }else{
                    chartContainer.find(".showDrill").show();
                }
                var offset = angular.element(event.target).offset();
                var height = (chartContainer[0]?.offsetHeight || 0);
                var width = (chartContainer[0]?.offsetWidth || 0);
                var drillContainer = angular.element(".showDrill");
                drillContainer[0].style.top = height/2 - 33 + 'px';
                drillContainer[0].style.left = width/2 -70 + 'px';
                if(typeof(obj) == 'string') {
                    var arr11 = [],
                        convertedArray = [];
                    for (var i = 0; i < arguments.length; ++i) {
                        arr22 = arguments[i].split(":");
                        for (var f = 1; f < arr22.length; f++) {
                            if (arr22[f][0] == '"') {
                                if (arr22[f][arr22[f].length - 1] != '"' && arr22[f][arr22[f].length - 1] != '}') {
                                    arr22[f] = arr22[f] + '"';
                                }
                            }
                        }
                        arr11.push(arr22.join(':'));
                    }
                    // arguments = arr11;
                    for(var i = 0; i < arr11.length; ++i) {
                        convertedArray.push(arr11[i]);
                    }
                    var argsString = convertedArray.join(',"');
                    $rootScope.chartFilterObj = JSON.parse(argsString);
                    $compile(drillContainer)(scope);
                    //FC end
                }
            };
            window.loadFilteredDataView = function(elem, viewType){
                // event.preventDefault();
                // event.stopPropagation();
                var selectedFilter;
                if(_.isEmpty(filterDataJson)){
                    filterDataJson = JSON.parse(JSON.stringify(defaultFilterDataJson));
                    scope.initFilters().then(function() {
                        selectedFilter = filterMetaDataJson.filter((obj) => {
                            if (obj.id == scope.chartFilterObj.filterId || (obj.roleGroupId && (obj.roleGroupId == scope.chartFilterObj.roleGroupId))) {
                                return obj;
                            }
                        })[0];
                        scope.setFiltersAndUpdateView(selectedFilter,viewType);
                    }).catch(error => window.systemWarning(error));
                }else{
                    selectedFilter = filterMetaDataJson.filter((obj)=>{
                        if(obj.id == scope.chartFilterObj.filterId || (obj.roleGroupId && (obj.roleGroupId == scope.chartFilterObj.roleGroupId))){
                            return obj;
                        }
                    })[0];
                    scope.setFiltersAndUpdateView(selectedFilter,viewType);
                }
                angular.element(elem.closest(".showDrill")).hide();
            };
            scope.setFiltersAndUpdateView = function(selectedFilter,viewType){
                if(!filterDataJson[scope.chartFilterObj.filterId]) {
                    if(selectedFilter && !selectedFilter.data){
                        selectedFilter.data = filterDefaultDataJson[scope.chartFilterObj.filterId]
                    }
                    filterDataJson[scope.chartFilterObj.filterId] = selectedFilter?.data;
                    if(selectedFilter && selectedFilter.uiType != "INPUTTEXT"){
                        if(_.has(filterDataJson[scope.chartFilterObj.filterId], "multiselectValues")) filterDataJson[scope.chartFilterObj.filterId]['multiselectValues'] = {};
                    }
                }
                var arrayTypeFilters = ["MULTISELECT","STATUS"];
                var mountAt = '#listing-panel-left';
                let filterObject = {};
                if(selectedFilter && selectedFilter['queryName'] == 103503){
                    const selData =  filterDataJson[scope.chartFilterObj.filterId]['multiselectValues']['SELECTEDDATA'];
                    let index = _.findIndex(selData, (obj) =>obj.id == scope.chartFilterObj.optionName);
                    if(index == -1){
                        const dataObj = {id: scope.chartFilterObj.optionName, name: scope.chartFilterObj.optionName == true ? "Yes" : "No" };
                        filterDataJson[scope.chartFilterObj.filterId]['multiselectValues']['SELECTEDDATA'].push(dataObj);
                    }
                }else if(arrayTypeFilters.includes(selectedFilter?.uiType)){
                    if(scope.chartFilterObj.optionId == 0 && ["BLANK", "NOT_BLANK"].includes(scope.chartFilterObj.optionName)) {
                        filterDataJson[scope.chartFilterObj.filterId].operator= scope.chartFilterObj.optionName;
                        filterDataJson[scope.chartFilterObj.filterId]['multiselectValues']['SELECTEDDATA'] = [];
                    } else {
                        filterDataJson[scope.chartFilterObj.filterId].operator = "OR";
                        filterDataJson[scope.chartFilterObj.filterId]['multiselectValues']['SELECTEDDATA'] = [{
                            id: scope.chartFilterObj.optionId,
                            name: scope.chartFilterObj.optionName
                        }];
                    }
                }else if(selectedFilter && selectedFilter.uiType === 'SINGLESELECT'){
                    filterDataJson[scope.chartFilterObj.filterId]['multiselectValues']['SELECTEDDATA']= [{id:scope.chartFilterObj.optionId.toString(), name:scope.chartFilterObj.optionName}];
                }
                else if (selectedFilter && selectedFilter.uiType === 'STAKEHOLDER') {
                    filterDataJson[scope.chartFilterObj.filterId]['multiselectValues']['SELECTEDDATA']= [{ group: [{id:scope.chartFilterObj.optionId, name:scope.chartFilterObj.optionName, idType:1, selected:true}],id:JSON.stringify(scope.chartFilterObj.roleGroupId), name: "", type:"2"},{id:scope.chartFilterObj.optionId, name:scope.chartFilterObj.optionName, idType:1, selected:true}];
                } else if(selectedFilter && selectedFilter.uiType === "INPUTTEXT") {
                   const filterObj =  filterDataJson[scope.chartFilterObj.filterId]
                    filterDataJson[scope.chartFilterObj.filterId] = {filterId: filterObj.filterId, filterName: filterObj.filterName, entityFieldId: filterObj.entityFieldId, entityFieldHtmlType: filterObj.entityFieldHtmlType, min: scope.chartFilterObj.optionName};
                } else {
                    if(!filterDataJson[scope.chartFilterObj.filterId]){
                        filterDataJson[scope.chartFilterObj.filterId] = {}
                        filterDataJson[scope.chartFilterObj.filterId]['multiselectValues'] = {};
                    }
                    filterDataJson[scope.chartFilterObj.filterId]['multiselectValues']['SELECTEDDATA']= [{id:scope.chartFilterObj.optionId, name:scope.chartFilterObj.optionName}];
                }

                if(!$(".react-filter-btn").length){
                    angular.element('.filter-content').each(function (index) {
                        angular.element(this).populateCustomFilter({
                            "metaData": filterMetaDataJson,
                            "data": filterDataJson,
                            "allFilterData": defaultFilterDataJson
                        });
                    });
                } else {
                    filterObject = filterDataJson[scope.chartFilterObj.filterId];
                    const props = {
                        filterObject,
                        explicitlyApplyFilter: true,
                        filterMetaData : filterMetaDataJson
                    }
                    SirionUtils.openReactModalFromAngular(mountAt, props, 'filtertype', "FilterListingComponent", 'updateFilterFromOutsideChannel', 'updateFilterFromOutsideChannelSubscription');
                }

                scope.reloadListing();
                viewType == "viewList" ?  $rootScope.dashboardView = false : scope.onInit();
            };
            scope.saveForm = function(){
                if(!scope.selectedChartForm.chartName){
                    scope.chartNameError = "Please enter the chart name";
                    return;
                }
                $rootScope.dashboardList.forEach(obj => {
                    if (obj.chartName == scope.selectedChartForm.chartName) {
                        scope.chartNameError = intl_msg['28989'];
                        return;
                    }
                });
                if(scope.chartNameError){
                    return;
                }
                startLoader();
                let chartData = scope.selectedChartForm.chartData;
                if(scope.isAEListing && !scope.elasticListing) {
                    var endpoint = '/autoextraction/saveDashboard';
                }else {
                    endpoint = '/listingchart/saveDashboard/'+scope.listId;
                    chartData = _.omit(scope.selectedChartForm.chartData, ['sqlQuery', '$$hashKey']);
                }
                let postForm = {
                    chartName:scope.selectedChartForm.chartName,
                    chartType: scope.selectedChartForm.chartType.chartType
                };
                postForm = _.merge(postForm, chartData);
                const postData = {chartData : postForm};
                var promise = requestData("POST", endpoint, postData, false, "json");
                promise.success(function (data) {
                    if(data.success){
                        var message = data.response ? data.response : intl_msg[32275];
                        Toaster.create(message);
                        scope.closePopup(true);
                        // scope.openDashboardChart(scope.selectedChartForm.chartData, null)
                    }
                    stopLoader();
                });
            };
            scope.onInit();
            scope.closePopup = function(reload){
                scope.aeDashboardModalInstance.close();
                if(reload){
                    scope.loadDashboards();
                }
            }
            scope.filterChartType = function(){
                return function (item) {
                    return !scope.multiChartTypes.includes(item.chartType);
                };
            };
            $(document).off("click", "html", function(e){});
            $(document).on("click", "html", function(e){
                if(e.target.offsetParent && angular.element(e.target.offsetParent).hasClass('showDrill')){
                    return;
                }
                const elem = $(".showDrill");
                if(elem.is(":visible") ){
                    elem.hide();
                }
            });
            var cleanUp1 =  $rootScope.$on("filterDashboardData",function(e) {
                scope.onInit();
            })
            var cleanUp2 =  $rootScope.$on("resetAeListingDashboard",function(e) {
                 event && event.stopPropagation();
                 scope.onInit();
            });
            var cleanUp3 =  scope.$on("filterDashboardData",function(e) {
                scope.onInit();
            })
            scope.$on('$destroy', function () {
                cleanUp1();
                cleanUp2();
                cleanUp3();
            });
        }
    }

}
]);
